<template>
    <auth-layout>
        <auth-card-header title="Forgot your password?" />

        <validation-observer v-if="!sent" v-slot="{ handleSubmit }" slim>
            <form class="forgot-form" @submit.prevent="handleSubmit(submit)">
                <p class="forgot-intro">
                    Enter your user account's verified email address and we will send you a password reset link.
                </p>

                <validation-provider v-slot="{ errors }" rules="required|email" name="Email">
                    <c-input
                        v-model="email"
                        type="email"
                        label="Email"
                        placeholder="Type your email"
                        :error="!!errors[0]"
                        :error-msg="errors[0]"
                    />
                </validation-provider>

                <c-error v-if="errorMessage" :message="errorMessage" />

                <c-button
                    class="w-100"
                    type="submit"
                    variant="primary"
                    :text="sending ? 'Sending...' : 'Send password reset email'"
                    :disabled="sending"
                />
            </form>
        </validation-observer>

        <p v-else class="forgot-intro">
            If that email belongs to a Customily account, the password reset link is on its way.
        </p>

        <p class="signin-link"><a href="/signin">Back to log in</a></p>
    </auth-layout>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import AuthLayout from '@/components/Auth/AuthLayout.vue';
import AuthCardHeader from '@/components/Auth/AuthCardHeader.vue';
import CButton from '@/components/shared/CButton/CButton.vue';
import CError from '@/components/shared/CError.vue';
import CInput from '@/components/shared/CInput/CInput.vue';
import { sendPasswordResetEmail } from '@/api/auth';
import { externalAuthErrorMessage } from '@/utils/authUtils';

const email = ref('');
const sending = ref(false);
const sent = ref(false);
const errorMessage = ref('');

const submit = async () => {
    errorMessage.value = '';

    sending.value = true;
    try {
        await sendPasswordResetEmail(email.value.trim());
        sent.value = true;
    } catch (error) {
        errorMessage.value = externalAuthErrorMessage(error, 'We could not send the email. Please try again.');
    } finally {
        sending.value = false;
    }
};
</script>

<style scoped>
.forgot-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.forgot-intro {
    margin: 0;
    font-size: 14px;
}

.signin-link {
    margin: 0;
    font-size: 0.75rem;
    text-align: center;
}
</style>
